/** A newer machine result re-opens a previously rejected field for review. */
export function rejectionStillApplies(
  rejectedAt: string | null,
  machineUpdatedAts: Array<string | null | undefined>
): boolean {
  if (!rejectedAt) return true;
  return !machineUpdatedAts.some((updatedAt) => !!updatedAt && updatedAt > rejectedAt);
}
